import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconModule } from '@y42/core/icon';
import { JobStatusComponent } from './job-status.component';

@NgModule({
  imports: [CommonModule, FontAwesomeModule, MatTooltipModule, IconModule],
  exports: [JobStatusComponent],
  declarations: [JobStatusComponent],
  providers: [],
})
export class JobStatusModule {}
